// extracted by mini-css-extract-plugin
export default {"errors":"errors_errors__5XFhp","errors__error":"errors_errors__error__o-oUT"};